import { campaignGridBudgetCenterEntryStyle } from '@bingads-webui-campaign-react/common-styles';
import {
  getSharedHeaderStyles,
  getSharedFooterStyles,
  getSharedTableStyles,
} from './shared';
import getBodyStyles from './body';

export default (components, { palette }) => ({
  '& thead.header': {
    ...getSharedHeaderStyles(components, { palette }),
    '& tr th': {
      '&:first-child, &:nth-child(2), &:nth-child(3)': {
        borderLeft: 'none',
      },

      '&:first-child, &:nth-child(2), &:last-child': {
        borderRight: 'none',
      },
    },
  },
  '& tbody': getBodyStyles(components, { palette }),
  '& tfoot.footer': getSharedFooterStyles(components, { palette }),
  ...getSharedTableStyles(components, { palette }),
  '& .aggregated-row span.combinedBudgetGridCellValue': {
    paddingRight: '24px',
  },
  ...campaignGridBudgetCenterEntryStyle({ palette }),
});
